'use client';

import { cn } from '@lib/utils';
import { useTranslations } from 'next-intl';

import SubscribeMessage, { MessageType } from './subscribe-message';
import {
  useEmailInput,
  useSubscribeSubmit,
  useFormFocusState,
} from './subscribe-form.hook';
import { useState } from 'react';
import { TrackedButton } from '../button';

const SubscribeForm = () => {
  const t = useTranslations('Footer');

  const [messageType, setMessageType] = useState<MessageType>(null);

  const { focused, touched, onFormFocus, onFormBlur } = useFormFocusState();
  const { email, isEmailValid, onEmailChange } = useEmailInput(setMessageType);
  const { onFormSubmit, onSubmitOnEnter, isLoading } = useSubscribeSubmit(
    setMessageType,
    email,
  );

  const isFormFocused = focused || !isEmailValid || touched;
  const disabledButton = !isEmailValid || isLoading;

  const inputClassName = cn(
    'required email h-[60px] w-full overflow-hidden rounded-bl-[10px] rounded-tl-[10px] border-2 border-3b-blue-light-900 pl-[20px] focus:border-3b-red-light-600 focus:bg-white focus:outline-none active:border-3b-red-light-600',
    isFormFocused ? 'border-3b-red-light-600' : '',
  );

  const buttonClassName = cn(
    'submit h-[60px] w-[150px] cursor-pointer overflow-hidden rounded-br-[10px] rounded-tr-[10px] border-none bg-3b-blue-light-900 text-sm font-bold leading-[29px] text-white focus:bg-3b-red-light-600 focus:outline-none active:bg-3b-red-light-600',
    isFormFocused ? 'bg-3b-red-light-600' : '',
  );

  return (
    <form className="mb-4" onSubmit={e => e.preventDefault()}>
      <div
        className="flex h-[60px] w-full"
        onFocus={onFormFocus}
        onBlur={onFormBlur}
      >
        <input
          type="email"
          value={email}
          name="email"
          className={inputClassName}
          placeholder={t('subscribe.placeholder')}
          aria-label={t('subscribe.placeholder')}
          aria-invalid={
            messageType === 'invalid-email' ||
            messageType === 'required' ||
            undefined
          }
          aria-describedby={
            messageType ? 'footer-subscribe-message' : undefined
          }
          autoComplete="email"
          onChange={onEmailChange}
          onKeyDown={onSubmitOnEnter}
        />
        <TrackedButton
          label="subscribe-button"
          position="footer"
          onClick={onFormSubmit}
          disabled={disabledButton}
          className={buttonClassName}
        >
          {t('subscribe.button')}
        </TrackedButton>
      </div>

      <SubscribeMessage messageType={messageType} />
    </form>
  );
};

export default SubscribeForm;
